<template>
  <div
    v-if="clientVehicle"
    class="inline-flex items-center w-full px-3 py-2 mb-5 space-x-4 text-sm leading-snug bg-gray-300 rounded-sm lg:w-auto text-darkblue"
  >
    <div class="py-1 pl-1 w-18" v-if="clientVehicle.image && clientVehicle.image">
      <img :src="`data:image/png;base64, ${clientVehicle.image}`" alt="Car Photo" />
    </div>
    <div class="w-full">
      <div class="block w-full text-left">
        <strong>{{ $t("sidebar.model") }}:</strong> <span>{{ clientVehicle.model }}</span>
      </div>
      <div class="block w-full text-left">
        <strong>{{ $t("sidebar.type") }}:</strong>
        <span class="whitespace-no-wrap">
          {{ clientVehicle.type }} ({{ clientVehicle.yearrange }})</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    showVehicleImage: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState({
      clientVehicle: state => state.apiData.clientVehicle
    })
  }
};
</script>

<style lang="scss" scoped></style>
